export const weighbridgeOpsAr = {
  weighbridgeOps: {
    title: 'عمليات الموازين',
    subtitle: 'مراقبة الميزان الحي والتقاط الأوزان',
    connection: {
      connected: 'متصل',
      connecting: 'جاري الاتصال...',
      reconnecting: 'إعادة الاتصال...',
      disconnected: 'غير متصل',
      noInternet: 'لا يوجد إنترنت',
    },
    stage: {
      firstWeight: 'الوزن الأول',
      secondWeight: 'الوزن الثاني',
    },
    gate: {
      entry: 'بوابة الدخول',
      exit: 'بوابة الخروج',
      open: 'مفتوح',
      closed: 'مغلق',
      openBtn: 'فتح',
      closeBtn: 'إغلاق',
      notConfigured: 'غير مكوّن',
      openAria: 'فتح',
      closeAria: 'إغلاق',
    },
    panel: {
      firstWeight: 'الوزن الأول',
      secondWeight: 'الوزن الثاني',
      idle: 'في انتظار الشاحنة',
      capturing: 'جاري الالتقاط...',
      captured: 'تم التقاط الوزن',
      capturedAt: 'تم الالتقاط في',
      error: 'فشل الالتقاط',
      captureButton: 'التقاط الوزن',
      override: 'تجاوز — التقاط الآن',
      weightUnit: 'كجم',
      adminOverrideTitle: 'إدخال الوزن يدوياً',
      weightPlaceholder: 'أدخل الوزن (كجم)',
      setWeight: 'تعيين الوزن',
      enterOrderFirst: 'أدخل رقم الطلب أولاً',
      saveContinue: 'حفظ ومتابعة',
      saving: 'جارٍ الحفظ…',
      clearWeight: 'مسح',
      zeroCheck: {
        title: 'فحص الميزان',
        reading: 'الميزان يقرأ {{weight}} كجم — انتظار الصفر',
      },
      stageLocked: 'المرحلة مقفلة',
      stageLockedByOrder: '— خطأ للطلب {{orderNumber}}.',
      stageLockedOpenGate: 'افتح بوابة الخروج للإلغاء.',
      stageLockedTitle:
        'مقفل بالطلب {{orderNumber}} — افتح بوابة الخروج للإلغاء',
      stageLockedTitleNoOrder: 'المرحلة مقفلة — افتح بوابة الخروج للإلغاء',
      lockedBadge: 'مقفل · {{orderNumber}}',
      lockedBadgeNoOrder: 'مقفل',
      inQueueBadge: '{{count}} في الانتظار',
      overweightWarning: {
        title: 'تحذير: فارق في الوزن',
        description:
          'الوزن الصافي {{netWeight}} يختلف عن المخطط {{plannedWeight}} بمقدار {{deltaKg}} كجم.',
      },
      overweightConfirm: {
        title: '⚠ فارق في الوزن — إجراء مطلوب',
        description:
          'الوزن الصافي {{netWeight}} كجم يختلف عن المخطط {{plannedWeight}} كجم بمقدار {{deltaKg}} كجم. كيف تريد المتابعة؟',
        continueBtn: 'متابعة وإرسال',
        rejectBtn: 'رفض وتخطي',
      },
      recordedWeights: 'الأوزان المسجلة',
      tare: 'الوزن الفارغ',
      gross: 'الوزن الإجمالي',
      net: 'الوزن الصافي',
      liveWeightSummary: {
        title: 'ملخص الأوزان',
        tare: 'الوزن الفارغ (الأول)',
        gross: 'الوزن الإجمالي (الثاني)',
        inboundGross: 'الوزن الإجمالي (الأول)',
        inboundTare: 'الوزن الفارغ (الثاني)',
        net: 'الوزن الصافي',
        noTare: 'لم يتم تسجيل وزن الخزان لهذا الطلب بعد',
        noGross: 'لم يتم تسجيل الوزن الإجمالي لهذه الشحنة بعد',
      },
    },
    queue: {
      title: 'قائمة الانتظار',
      empty: 'لا توجد شاحنات في الانتظار',
      manualEntry: 'إدخال رقم الطلب يدوياً',
      manualInboundEntry: 'إدخال رقم الشحنة يدوياً',
      manualPlaceholder: 'رقم الطلب',
      manualInboundPlaceholder: 'رقم الشحنة',
      inbound: 'وارد',
      outbound: 'صادر',
      orderNumber: 'الطلب',
      shipmentNumber: 'الشحنة',
      waitJustNow: 'قبل قليل',
      waitSeconds: '{{secs}} ث',
      waitMinutesSeconds: '{{mins}} د {{secs}} ث',
      statusActive: 'نشط',
      statusWaiting: 'انتظار',
      removeFromQueue: 'إزالة من قائمة الانتظار',
      removeFromQueueTitle:
        'الطلب {{orderNumber}} في قائمة الانتظار — انقر للإزالة',
      driver: 'السائق',
      plate: 'لوحة السيارة',
      firstWeight: 'الوزن الأول',
      secondWeight: 'الوزن الثاني',
      firstWeightLabel: 'و1',
      secondWeightLabel: 'و2',
      packagingBags: 'أكياس',
      packagingBulk: 'سائب',
      plannedWeight: 'الوزن المخطط',
      plannedWeightValue: '{{weight}} كجم',
      weightPending: '—',
      loadingDetails: 'جارٍ تحميل التفاصيل...',
    },
    history: {
      title: 'سجل الجلسة',
      empty: 'لا توجد أحداث بعد',
      clearButton: 'مسح',
      sinceNote: 'منذ فتح الاتصال — في الذاكرة فقط',
      connected: 'تم الاتصال بوحدة التحكم في الميزان',
      disconnected: 'تم قطع الاتصال من وحدة التحكم',
      internetConnected: 'تم استعادة الاتصال بالإنترنت',
      internetDisconnected: 'انقطع الاتصال بالإنترنت',
      orderQueued:
        'تمت إضافة {{flowLabel}} {{identifier}} إلى الصف عبر {{source}} — {{stage}}',
      orderEnqueued: '{{flowLabel}} {{identifier}} في الانتظار — {{stage}}',
      captureStarted: 'بدأ التقاط {{stage}}{{orderSuffix}}',
      weightCaptured: 'تم التقاط {{stage}}: {{weight}} كجم{{orderSuffix}}',
      weightSaved: 'تم حفظ {{stage}}: {{weight}} كجم{{orderSuffix}}',
      captureError: 'خطأ في {{stage}}: {{error}}{{orderSuffix}}',
      gateChanged: 'البوابة {{gate}} أصبحت {{status}}{{stageSuffix}}',
      anprDetected: 'ANPR: {{plate}}{{orderSuffix}}',
      scaleNotClear:
        'الميزان غير صافٍ ({{weight}} كجم) — المحاولة {{attempt}}/{{maxAttempts}}',
      scaleCleared: 'الميزان جاهز — تم التصفية',
      truckDeparted: 'غادرت الشاحنة — تم إغلاق بوابة الخروج',
      sourceQrScan: 'مسح QR',
      sourceAnpr: 'ANPR',
      sourceManual: 'إدخال يدوي',
      stageLocked:
        '⚠️ {{stage}} مقفل — خطأ في {{flowLabel}} {{identifier}}. افتح بوابة الخروج للإلغاء.',
      stageUnlocked: '✅ {{stage}} تم فتح القفل — استئناف العمل الطبيعي.',
      captureRequestFailed: 'فشل طلب الالتقاط: {{error}}',
      bootSnapshot: 'لقطة حالة وحدة التحكم عند تحميل الصفحة',
      bootLog: '📋 {{message}}',
      gateOpenFailed: 'فشل فتح البوابة: {{error}}',
      gateOpenError: 'خطأ في فتح البوابة: {{error}}',
      gateCloseFailed: 'فشل إغلاق البوابة: {{error}}',
      gateCloseError: 'خطأ في إغلاق البوابة: {{error}}',
      saveNoController: 'فشل الحفظ: رابط وحدة التحكم غير مكوّن',
      saveSubmitted: 'تم إرسال حفظ {{stage}}: {{weight}} كجم ({{orderNumber}})',
      saveFailed: 'فشل الحفظ: {{error}} ({{orderNumber}})',
      saveAckTimeout:
        '⚠️ انتهت مهلة تأكيد الحفظ — قد يكون حدث WS مفقوداً. تم إعادة تفعيل زر الحفظ.',
      overweightConfirmRequired: '⚠️ تم اكتشاف وزن زائد — إجراء مشغل مطلوب',
      boot: {
        gate_open_command_issued: 'تم إصدار أمر فتح البوابة ({{stage}})',
        gate_close_command_issued: 'تم إصدار أمر إغلاق البوابة ({{stage}})',
        truck_departed: 'غادرت الشاحنة',
      },
    },
    zone: {
      loading: 'تحميل منطقة الموازين...',
      noZone: 'لم يتم العثور على منطقة موازين لهذا المصنع.',
      noController:
        'لم يتم تكوين رابط جهاز التحكم. يرجى التواصل مع مسؤول النظام.',
      noTenantOrFactory: 'لا يوجد مستأجر أو مصنع مرتبط بحسابك.',
    },
    errors: {
      fetchZoneFailed: 'فشل تحميل منطقة الموازين',
      flowBusy: 'الميزان مشغول. يرجى الانتظار والمحاولة مجدداً.',
      flowBusyOrder:
        'الميزان مشغول بمعالجة الطلب {{orderNumber}}. يرجى الانتظار.',
      // Fulfillment controller / service
      orderNumberRequired: 'رقم الطلب مطلوب',
      tareWeightRequired: 'وزن الفارغ مطلوب',
      grossWeightRequired: 'الوزن الإجمالي مطلوب',
      licensePlateRequired: 'رقم لوحة المركبة مطلوب',
      firstWeighFailed: 'فشل تسجيل الوزن الأول',
      secondWeighFailed: 'فشل تسجيل الوزن الثاني',
      validateOrderFailed: 'فشل التحقق من الطلب',
      resolveByPlateFailed: 'فشل تحديد الطلب من لوحة المركبة',
      orderNotFound: 'الطلب غير موجود',
      shipmentNotFound: 'الشحنة غير موجودة لهذا الطلب',
      tareWeightImmutable: 'لا يمكن تحديث وزن الفارغ بعد تسجيل الوزن الإجمالي',
      netWeightInvalid: 'يجب أن يكون الوزن الصافي أكبر من صفر',
      orderAlreadyProcessing: 'الطلب قيد المعالجة بالفعل',
      orderStatusInvalid: 'لا يمكن معالجة الطلب — ليس في الحالة المطلوبة',
      orderStatusNotProcessing: 'يجب أن تكون حالة الطلب قيد المعالجة',
      shipmentResourceRequired: 'مورد الشحنة مطلوب قبل بدء المعالجة',
      shipmentNotLoading: 'يجب أن تكون الشحنة في حالة التحميل للوزن الثاني',
      firstWeighRequired: 'يجب إتمام الوزن الأول (وزن الفارغ) قبل الوزن الثاني',
      firstWeighAlreadyCompleted: 'تم إكمال الوزن الأول لهذه الشحنة بالفعل',
      firstAndSecondWeighRequired: 'يجب إكمال الوزن الأول والثاني قبل الخروج',
      bagsVarianceNotConfigured: 'فحص تباين الأكياس غير مكوّن لهذا النوع',
      bagsWeightVarianceExceeded:
        'تباين الوزن {{variancePercent}}% يتجاوز الحد المسموح {{thresholdPercent}}% لطلبات الأكياس. المخطط: {{plannedTonnes}}ط، الفعلي: {{actualTonnes}}ط',
      contractOverload:
        'تم إيقاف الوزن الثاني بسبب تجاوز العقد. تكلفة الزيادة {{actualCost}} تتجاوز رصيد العقد المتاح {{availableBalance}}. العجز: {{deficit}}.',
      assetNotFoundForPlate: 'لا يوجد أصل نشط لرقم اللوحة هذا',
      assetNotInResource: 'تم العثور على الأصل لكنه غير مخصص لأي مورد نشط',
      resourceNotInShipment: 'تم العثور على المورد لكنه غير مخصص لأي شحنة',
      noOrderForPlate: 'لم يتم العثور على طلب نشط لرقم لوحة المركبة',
      resourceNotFound: 'المورد المحدد غير موجود',
      tenantRequired: 'العميل مطلوب لتعيين المورد',
      // Edge command controller
      siteIdRequired: 'معرّف الموقع مطلوب',
      pollCommandsFailed: 'فشل استطلاع الأوامر',
      invalidCommandStatus: 'حالة الأمر يجب أن تكون مكتمل أو فاشل',
      edgeCommandNotFound: 'أمر الحافة غير موجود',
      edgeCommandAlreadyAcked: 'تم إقرار الأمر بالفعل',
      ackCommandFailed: 'فشل إقرار الأمر',
      // QR scan controller / service
      zoneCodeRequired: 'رمز المنطقة مطلوب',
      pathIdRequired: 'معرّف المسار مطلوب',
      gateNotFound: 'تعذّر تحديد البوابة لهذا المسح',
      gateDirectionNotConfigured: 'البوابة لا تحتوي على اتجاه دخول أو خروج',
      weighbridgeZoneNotAllowed:
        'منطقة الموازين غير مسموح بها لهذا النوع من الدخول',
      employeeNotFound: 'الموظف غير موجود أو غير نشط',
      orderNoFactory: 'الطلب لا يحتوي على مصنع مخصص',
      gateNoFactory: 'البوابة لا تحتوي على مصنع مخصص',
      factoryMismatch: 'عدم تطابق المصنع — المركبة مسجلة في مصنع مختلف',
      orderNoId: 'الطلب لا يحتوي على معرّف رقمي',
      queueTicketRequired:
        'تذكرة قائمة الانتظار مطلوبة. يرجى زيارة الكشك للانضمام إلى الصف.',
      sapSalesOrderRequired:
        'لم يتم إنشاء أمر مبيعات SAP. يرجى إعادة الانضمام إلى الصف من الكشك.',
      noAuthorizedAccess: 'لا يوجد تصريح دخول معتمد لهذه اللوحة',
      visitCannotCheckIn: 'تم رفض الدخول — الزيارة لم تُعتمد أو لم تُجدوَل بعد',
      visitBlacklisted: 'تم رفض الدخول — الزائر مُدرَج في قائمة المقيّدين',
      visitTooEarly: 'تم رفض الدخول — وصلت المركبة قبل النافذة الزمنية المحددة',
      visitExpired: 'تم رفض الدخول — انتهت صلاحية تصريح الزيارة',
      visitCannotCheckOut: 'لا يمكن تسجيل الخروج — لم يتم تسجيل الدخول',
      // Camera controller / service
      noGateForCamera: 'لا توجد بوابة مرتبطة بهذه الكاميرا',
      cannotResolveFactory: 'تعذّر تحديد المصنع من الطلب',
      factoryNotFound: 'المصنع غير موجود',
      invalidLicensePlate: 'صيغة رقم اللوحة غير صحيحة',
      gateDirectionMismatch: 'عدم تطابق اتجاه البوابة',
      // Additional keys
      cameraReadingFailed: 'فشل معالجة قراءة الكاميرا',
      gateResolveFailed: 'تعذّر تحديد البوابة لهذه الرصدة',
      gateNoDirection: 'البوابة ليس لها اتجاه دخول أو خروج محدد',
      weighbridgeZoneForbiddenEmployee: 'منطقة الميزان غير مسموح بها للموظفين',
      weighbridgeZoneForbiddenVisitor: 'منطقة الميزان غير مسموح بها للزوار',
      licensePlateInvalid: 'صيغة رقم اللوحة غير صحيحة',
      weighbridgeMeasurementsMissing:
        'لا يمكن الخروج — القياسات المطلوبة من الميزان مفقودة',
      weighbridgeNoStage: 'بوابة الميزان ليس لها مرحلة وزن محددة',
      queueExitFailed: 'فشل تحرير موضع الانتظار — يرجى المحاولة مرة أخرى',
      scaleNotClear:
        'الميزان غير خالٍ — قد تكون هناك شاحنة أخرى على المنصة. يرجى التحقق قبل إعادة المحاولة.',
      // Scan / assign-resource / fulfillment controller
      scanFailed: 'فشل مسح الطلب',
      suggestResourcesFailed: 'فشل اقتراح الموارد',
      assignResourceFailed: 'فشل تعيين المورد',
      resourceRequired: 'المورد مطلوب',
      licensePlateOrPhoneRequired: 'رقم اللوحة أو هاتف السائق مطلوب',
      startProcessingFailed: 'فشل بدء معالجة الطلب',
      generatePdfFailed: 'فشل إنشاء ملف PDF للطلب',
      syncInvoicesFailed: 'فشل مزامنة الفواتير للطلب',
      fetchLifecycleFailed: 'فشل تحميل دورة حياة الطلب',
      markDeliveredFailed: 'فشل تحديد الشحنة كمسلَّمة',
      noAssetType:
        'لم يتم العثور على نوع أصل نشط. يرجى تكوين نوع أصل واحد على الأقل.',
      invalidAssetType: 'تكوين نوع الأصل غير صالح',
      cannotDeliverCancelledShipment: 'لا يمكن تحديد شحنة ملغاة كمسلَّمة',
      createResourceFailed: 'فشل إنشاء المورد',
      createDriverFailed: 'فشل إنشاء السائق',
      createVehicleFailed: 'فشل إنشاء المركبة',
      // Gate / scale hardware errors (from weighbridge-controller)
      zkbioUnreachable: 'تعذّر الاتصال بجهاز البوابة ZKBio',
      zkbioInvalidResponse: 'استجابة غير صالحة من جهاز ZKBio',
      zkbioGateError: 'خطأ في بوابة ZKBio',
      gateOpenFailed: 'فشل فتح البوابة',
      gateCloseFailed: 'فشل إغلاق البوابة',
      gateAcknowledgeFailed: 'لم تستجب البوابة للأمر',
      gateStatusIsapiFailed: 'فشل قراءة حالة البوابة',
      gateStatusFailed: 'فشل قراءة حالة البوابة',
      scaleReadFailed:
        'فشل قراءة الميزان: تم تجاوز الحد الأقصى لمحاولات الاتصال',
      // Command payload errors
      missingGateIp: 'عنوان IP للبوابة غير مكوَّن لهذا الأمر',
      invalidDirection: 'يجب أن يكون الاتجاه وارد أو صادر',
      unsupportedShipmentId:
        'معرّف الشحنة غير مدعوم في تدفق الميزان الوارد. استخدم رقم الشحنة بدلاً من ذلك.',
      mixedIdentifiers:
        'استخدم إما رقم طلب صادر أو رقم شحنة واردة، وليس الاثنين معاً.',
      missingOrderNumber: 'رقم الطلب مطلوب',
      missingShipmentNumber: 'رقم الشحنة مطلوب',
      missingWeightStage:
        'مرحلة الوزن يجب أن تكون first_weight أو second_weight',
      invalidWeight: 'يجب أن يكون الوزن رقماً غير سالب',
      orderAlreadyQueued:
        'هذا الطلب موجود بالفعل في قائمة الانتظار لهذه المنطقة',
      zoneLocked: 'منطقة الجسر مقفلة — افتح بوابة الخروج للفتح',
      zoneBusy: 'منطقة الجسر مشغولة — يرجى الانتظار والمحاولة مجدداً',
      controllerRequestFailed:
        'تعذّر الاتصال بوحدة تحكم الميزان.',
      // Hardware controller errors
      cameraEventFailed: 'فشل معالجة حدث الكاميرا',
      qrScanFailed: 'فشل معالجة مسح الرمز',
      // ZKBio gate / door poller
      zkbioOpenFailed: 'فشل فتح البوابة {{gateCode}}',
      zkbioDoorTimeout: 'لم تُغلق البوابة في الوقت المتوقع',
      // ANPR / camera
      anprMissingPlate: 'لوحة الترخيص غير موجودة في قراءة الكاميرا',
      anprRejected: 'رفض الخادم قراءة الكاميرا',
      anprForwardFailed: 'فشل إرسال قراءة الكاميرا إلى الخادم',
      // QR scan
      qrMissingOrderNumber: 'مسح QR لا يتضمن رقم الطلب',
      qrRejected: 'رفض الخادم مسح QR',
      qrForwardFailed: 'فشل إرسال مسح QR إلى الخادم',
      // Weighbridge flow
      duplicateFlow: 'الطلب {{orderNumber}} قيد المعالجة بالفعل في هذه المرحلة',
      orderAlreadyWeighed:
        'تم تسجيل هذا الوزن بالفعل لـ {{orderNumber}}',
      weightSubmissionFailed:
        'فشل إرسال الوزن — تم قفل المرحلة لـ {{flowLabel}} {{identifier}}.',
      // رفض من SAP يتم التعرف عليه في services/sap-integration/errors/map-cpi-error.ts
      sapInsufficientBalance:
        'رفض نظام SAP الوزن — رصيد العقد غير كافٍ لهذه الحمولة.',
      sapContractOverload:
        'رفض نظام SAP الوزن — هذه الحمولة تتجاوز القيمة المتبقية في العقد.',
      netWeightMismatch:
        'الوزن الصافي لا يساوي الوزن الإجمالي ناقص وزن الفارغ',
      strapiUnauthorized: 'غير مصرح بإرسال الوزن',
      strapiForbidden: 'إرسال الوزن ممنوع — أذونات غير كافية',
      requestTimeout:
        'استغرق الخادم وقتاً طويلاً للرد — الاتصال بطيء. قد يكون الوزن حُفظ وقد لا يكون.',
      saveAckTimeout:
        'من فضلك تحقق من الوزن من صفحة تصحيح الأوزان.',
      strapiUnreachable:
        'لا يوجد اتصال بالإنترنت — تعذّر إرسال الوزن إلى الخادم.',
      flowFailed: 'فشل تدفق الجسر',
      weightReadFailed: 'فشل قراءة الوزن',
      gateTestFailed: 'فشل اختبار فتح البوابة',
      // ضوابط مراحل الشحنة الواردة (incoming-materials/inbound-flow.functions.ts)
      firstWeightStageLocked:
        'لا يمكن تسجيل الوزن الأول — حالة الشحنة الحالية "{{status}}" (المتوقع: "وصلت")',
      secondWeightBeforeFirst: 'لا يمكن تسجيل الوزن الثاني قبل الوزن الأول',
      secondWeightStageLocked:
        'لا يمكن تسجيل الوزن الثاني — حالة الشحنة الحالية "{{status}}" (المتوقع: "تم الوزن الأول" أو "تم التفريغ")',
      finalizeStageLocked:
        'لا يمكن إنهاء الشحنة — الحالة الحالية "{{status}}" (المتوقع: "تم الوزن الثاني")',
      exitBeforeSecondWeight:
        'لا يمكن الخروج — حالة الشحنة "{{status}}". يجب تسجيل الوزن الثاني أولاً',
      goodsReceiptAlreadyExists: 'تم إنشاء إيصال استلام البضائع لهذه الشحنة بالفعل',
      // تسجيل وزن الشحنة الواردة (api/inbound-shipment/controllers/inbound-shipment.ts recordWeight)
      weightTypeInvalid: 'نوع الوزن يجب أن يكون "F" أو "S"',
      fieldMustBePositive: 'يجب أن يكون {{field}} رقماً موجباً',
      invalidShipmentId: 'معرّف الشحنة غير صالح',
      poMissingSapNumberForWeight:
        'أمر الشراء المرتبط لا يحتوي على رقم أمر شراء SAP — يتعذر إرسال الوزن إلى SAP',
      sapWeightPushFailed: 'تم تسجيل الوزن محلياً لكن فشل إرساله إلى SAP: {{reason}}',
      noWeighbridgeTicketForShipment: 'لم يتم العثور على تذكرة ميزان لهذه الشحنة',
      firstWeightTicketMissingGross: 'تذكرة الوزن الأول لا تحتوي على الوزن الإجمالي',
      shipmentMissingPurchaseOrder: 'الشحنة غير مرتبطة بأمر شراء',
      noPurchaseOrderLinesForGrn: 'لم يتم العثور على بنود أمر الشراء لإنشاء إيصال الاستلام تلقائياً',
      grnSapPushFailed: 'تم إنشاء إيصال الاستلام لكن فشل إرساله إلى SAP: {{reason}}',
      secondWeightGrnFailed:
        'تم تسجيل الوزن الثاني لكن فشل إنشاء إيصال الاستلام التلقائي: {{reason}}',
      // مفاتيح موجودة مسبقاً في الخادم دون ترجمة
      fetchOrderDetailsFailed: 'فشل جلب تفاصيل الطلب',
      inboundShipmentNotFound: 'لم يتم العثور على الشحنة الواردة',
      platePairingRequired: 'لم يتم العثور على قراءة لوحة السيارة — لن تُفتح البوابة',
      inboundQrDisabled: 'تسجيل الشحنات الواردة غير مُفعّل في هذا الموقع',
      purchaseOrderNumberRequired: 'رقم أمر الشراء مطلوب',
      purchaseOrderLineRequired: 'اختر الحمولة التي تقوم بتوصيلها',
      purchaseOrderLineNotFound: 'لا يوجد بند بهذا الرقم في أمر الشراء',
      purchaseOrderNotSyncedToSap:
        'لم تتم مزامنة أمر الشراء مع SAP — لا يمكن تسجيل الوصول',
      vehicleAlreadyInside:
        'لهذه المركبة توصيلة مفتوحة بالفعل — يجب أن تخرج قبل بدء توصيلة أخرى',
      purchaseOrderNotFound: 'لم يتم العثور على أمر الشراء',
      purchaseOrderCancelled: 'أمر الشراء ملغى',
      purchaseOrderClosed: 'أمر الشراء مغلق',
      sapSalesOrderNumberRequired: 'الطلب لا يحتوي على رقم أمر مبيعات SAP',
      sapWeightSyncDisabled: 'مزامنة الوزن مع SAP معطّلة',
      secondWeighAlreadyCompleted: 'تم تسجيل الوزن الثاني بالفعل',
    },
    /**
     * ما يجب على المشغّل فعله لكل خطأ. المفاتيح مطابقة لمفاتيح `errors.*`
     * (انظر domain/utils/error-remedy.ts) — أي مفتاح بدون إرشاد يرجع إلى `default`.
     */
    remedies: {
      default: 'سجّل رقم الطلب واتصل بقسم تقنية المعلومات.',
      requestTimeout:
        'لا تحفظ مرة أخرى الآن. تحقق أولاً من الأوزان المسجلة بالأسفل — إذا ظهر الوزن فقد تم حفظه. وإن لم يظهر، انتظر ٣٠ ثانية ثم احفظ مرة واحدة.',
      saveAckTimeout:
        'لا تحفظ مرة أخرى قبل التحقق — الحفظ مرتين قد ينشئ وزناً مكرراً. ابحث هناك برقم الطلب، وإذا لم يظهر الوزن احفظ مرة واحدة فقط.',
      fetchZoneFailed:
        'حدّث الصفحة. إذا لم تُحمّل، تحقق من الاتصال بالإنترنت ثم اتصل بقسم تقنية المعلومات.',
      // SAP / العقد
      sapInsufficientBalance:
        'لا تسمح للشاحنة بالمغادرة. اطلب من السائق أن يقوم العميل بتغذية رصيد العقد، ثم أعد الوزن.',
      sapContractOverload:
        'قلّل الحمولة، أو اطلب من العميل تمديد العقد، ثم أعد الوزن.',
      contractOverload:
        'قلّل الحمولة، أو اطلب من العميل تمديد العقد، ثم أعد الوزن.',
      firstWeighFailed: 'حاول مرة أخرى. إذا فشل مرة ثانية، اتصل بقسم تقنية المعلومات.',
      secondWeighFailed: 'حاول مرة أخرى. إذا فشل مرة ثانية، اتصل بقسم تقنية المعلومات.',
      sapSalesOrderNumberRequired:
        'لم يتم إنشاء هذا الطلب في SAP. أعد السائق إلى الكشك للانضمام إلى الطابور مجدداً.',
      sapWeightSyncDisabled: 'اتصل بقسم تقنية المعلومات — مزامنة الوزن مع SAP متوقفة.',
      // الاتصال
      strapiUnreachable:
        'تحقق من كابل الشبكة والواي فاي، انتظر ٣٠ ثانية، ثم اضغط حفظ مرة أخرى. إذا فشل ٣ مرات، اتصل بقسم تقنية المعلومات.',
      controllerRequestFailed:
        'تأكد من أن صندوق وحدة تحكم الميزان يعمل، انتظر ٣٠ ثانية، ثم حاول مرة أخرى. إذا فشل ٣ مرات، اتصل بقسم تقنية المعلومات.',
      weightSubmissionFailed:
        'افتح بوابة الخروج لإلغاء قفل المرحلة، ثم أعد وزن هذه الشاحنة.',
      strapiUnauthorized:
        'اخرج من النظام ثم سجّل الدخول مجدداً. إذا تكرر الأمر، اتصل بقسم تقنية المعلومات.',
      strapiForbidden: 'حسابك غير مصرّح له بتسجيل الأوزان — راجع مشرفك.',
      // أجهزة الميزان
      scaleNotClear:
        'تأكد أن منصة الميزان خالية تماماً، ثم حاول مرة أخرى. إذا لم يصل الميزان إلى الصفر، اتصل بقسم تقنية المعلومات.',
      scaleReadFailed:
        'تأكد أن شاشة الميزان تعمل وتُظهر وزناً، ثم حاول مرة أخرى. إذا فشل ٣ مرات، اتصل بقسم تقنية المعلومات.',
      weightReadFailed:
        'تأكد أن شاشة الميزان تعمل وتُظهر وزناً، ثم حاول مرة أخرى. إذا فشل ٣ مرات، اتصل بقسم تقنية المعلومات.',
      // البوابات
      gateOpenFailed:
        'اضغط الزر مرة أخرى. إذا لم تتحرك البوابة، افتحها يدوياً واتصل بقسم تقنية المعلومات.',
      gateCloseFailed:
        'اضغط الزر مرة أخرى. إذا لم تتحرك البوابة، أغلقها يدوياً واتصل بقسم تقنية المعلومات.',
      gateAcknowledgeFailed:
        'تحقق مما إذا كانت البوابة قد تحركت فعلاً. إن لم تتحرك، اتصل بقسم تقنية المعلومات.',
      zkbioUnreachable:
        'وحدة تحكم البوابة غير متصلة — افتح البوابة يدوياً واتصل بقسم تقنية المعلومات.',
      zkbioDoorTimeout: 'تأكد من عدم وجود ما يعيق البوابة، ثم حاول إغلاقها مرة أخرى.',
      // حالة الطلب / التدفق
      orderNotFound: 'تحقق من رقم الطلب مع السائق وأدخله مرة أخرى.',
      shipmentNotFound: 'أعد السائق إلى الكشك للانضمام إلى الطابور مجدداً.',
      orderStatusNotProcessing:
        'لم يبدأ هذا الطلب بعد. أرسل السائق إلى الكشك أولاً.',
      shipmentNotLoading: 'لم تُحمّل الشاحنة بعد. أرسلها إلى ساحة التحميل أولاً.',
      firstWeighRequired: 'قم بالوزن الأول (الشاحنة فارغة) قبل هذا الوزن.',
      firstWeighAlreadyCompleted:
        'الوزن الأول مسجّل بالفعل — أرسل هذه الشاحنة إلى ميزان الوزن الثاني.',
      secondWeighAlreadyCompleted:
        'تم وزن هذه الشاحنة بالكامل — اسمح لها بالتوجه إلى الخروج.',
      orderAlreadyWeighed: 'هذا الوزن محفوظ بالفعل — اسمح للشاحنة بالمرور.',
      netWeightInvalid:
        'الأوزان غير منطقية. أعد وزن الشاحنة؛ وإذا تكرر الأمر، اتصل بقسم تقنية المعلومات.',
      netWeightMismatch:
        'الأوزان غير منطقية. أعد وزن الشاحنة؛ وإذا تكرر الأمر، اتصل بقسم تقنية المعلومات.',
      duplicateFlow: 'هذه الشاحنة قيد المعالجة بالفعل — انتظر حتى تنتهي.',
      zoneLocked: 'افتح بوابة الخروج لإلغاء قفل الميزان، ثم حاول مرة أخرى.',
      zoneBusy: 'انتظر حتى تغادر الشاحنة التي أمامك الميزان، ثم حاول مرة أخرى.',
      flowBusy: 'انتظر حتى تغادر الشاحنة التي أمامك الميزان، ثم حاول مرة أخرى.',
      bagsWeightVarianceExceeded:
        'أعد عدّ الأكياس مع السائق. إذا كان العدد صحيحاً، راجع مشرفك قبل السماح للشاحنة بالمغادرة.',
    },
    info: {
      gateOpened: 'تم فتح البوابة {{gateCode}}',
      gateClosed: 'تم إغلاق البوابة {{gateCode}}',
      orderQueuedLocked:
        'الطلب {{orderNumber}} في الانتظار — في انتظار فتح المنطقة {{weightStage}}',
      orderQueued: 'الطلب {{orderNumber}} في الطابور بالموضع {{position}}',
      flowCompleted: 'اكتمل تدفق الجسر — الطلب {{orderNumber}}، {{weight}} كغ',
      anprAccepted: 'تم قبول قراءة الكاميرا',
      scanAccepted: 'تم قبول مسح QR',
      gateTestOpened: 'تم فتح البوابة التجريبية بنجاح',
    },
  },
};
